export default "__VITE_ASSET__DUyJwjCF__"